import {Http} from '@wix/wixstores-client-core/dist/es/src/http/http';
import {gqlQuery} from './getProduct';
import {SiteStore} from '@wix/wixstores-client-core/dist/es/src/viewer-script/site-store/siteStore';
import {query as getCartServiceQuery} from '../graphql/getCartService.graphql';
import {graphqlOperation} from '../constants';
import {GetCartServiceQuery} from '../graphql/queries-schema';

export const VolatileCartApiUrl = '/stores/v1/carts/volatileCart';

export class VolatileCartService {
  private _cartId: string;

  constructor(private readonly httpClient: Http, private readonly siteStore: SiteStore) {
    // noop
  }

  public getStandaloneCartId = async (
    productId: string,
    optionSelectionId: number[],
    quantity: number,
    customTextFieldSelection: {title: string; value: string}[],
    subscriptionOptionId?: string
  ): Promise<string> => {
    const response = await this.httpClient.post(VolatileCartApiUrl, {
      productId,
      optionSelectionId,
      customTextFieldSelection,
      quantity,
      subscriptionOptionId,
    });

    this._cartId = response.data.cart.id;
    return this._cartId;
  };

  public getCart = async (): Promise<GetCartServiceQuery> => {
    return (
      await gqlQuery(this.siteStore, getCartServiceQuery, {cartId: this._cartId}, graphqlOperation.GetCartService)
    ).data;
  };

  public get cartId() {
    return this._cartId;
  }
}
